<template>
  <el-dialog
    title="申请提现"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :width="dialogWidth"
    :z-index="2000"
    @close="handleClose"
  >
    <div>
      <div class="withdraw-item" style="flex-direction: row;">
        <span>可用金额: </span>
        <span>{{ balance }}</span>
      </div>
      <div class="withdraw-item">
        <span>提现金额: </span>
        <el-input v-model="form.amount" placeholder="请输入" @input="onInput" />
      </div>
      <div class="withdraw-item">
        <span>选择收款方式: </span>
        <el-select
          v-model="form.accountId"
          placeholder="请选择收款方式"
          class="filter-item"
          clearable
          @change="handleChange"
        >
          <el-option
            v-for="item in bankList"
            :key="item.id"
            :label="item.bankName"
            :value="item.id"
          />
        </el-select>
      </div>

      <div v-if="form.accountId" class="withdraw-bank">
        <div class="withdraw-item">
          <span class="label">银行名称</span>
          <span class="value">
            <el-image
              :src="getTableThumbnailImg(selectBank.bankLogo)"
              fit="cover"
              v-if="selectBank.bankLogo"
            ></el-image>
            <span class="bank-name">{{ selectBank.bankName }}</span>
          </span>
        </div>

        <div class="withdraw-item">
          <span class="label">支行名称</span>
          <span class="value truncate" :title="selectBank.branchName">{{
            selectBank.branchName
          }}</span>
        </div>

        <div class="withdraw-item">
          <span class="label">银行卡号</span>
          <span class="value truncate" :title="selectBank.bankAccount">{{
            selectBank.bankAccount
          }}</span>
        </div>

        <div class="withdraw-item">
          <span class="label">开户名</span>
          <span class="value truncate" :title="selectBank.accountName">{{
            selectBank.accountName
          }}</span>
        </div>
      </div>
      <div
        class=""
        style="display:flex;align-items:flex-start;margin-top: 10px;"
      >
        <span style="margin-right: 10px;">发票: </span>
        <UploadList
          :typeProps="UPLOAD_IMG_TYPE.COMMON"
          @valueFunc="getImgsValueFunc"
          paramsType="mainGraph"
          :model="invoiceImage"
          :maxCount="9"
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="saveData" :loading="btnLoading">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { UPLOAD_IMG_TYPE } from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList.vue";
import { getBankListQuery, addBankListQuery } from "@/api/account-profit";
import { getTableThumbnailImg } from "@/utils/utils";
import { getLogionUserInfo } from "@/utils/auth"; // 验权
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
export default {
  name: "WithdrawDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    balance: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: { UploadList },
  data() {
    return {
      btnLoading: false,
      bankList: [],
      form: {
        amount: null,
        accountId: ""
      },
      selectBank: {},
      isAgentLogin: null,
      agentUserId: "",
      invoiceImage: []
    };
  },
  computed: {
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    dialogWidth() {
      return window.innerWidth <= 768 ? "92%" : "60%";
    },
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    }
  },
  created() {
    this.form = {};
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.agentUserId =
      (this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT && this.disabled) ||
      this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        ? this.agentDetail?.agentUserId
        : getLogionUserInfo()?.agentUserId;
      
    this.invoiceImage = [];
  },
  mounted() {
    this.getBankList();
  },
  methods: {
    getTableThumbnailImg,
    getImgsValueFunc(type, value) {
      this.form.invoiceImage = value.map(item => item.url).join(",");
      console.log(this.form.invoiceImage);
    },
    getBankList() {
      getBankListQuery({ agentUserId: this.agentUserId }).then(res => {
        console.log(res);
        this.bankList = res.data;
      });
    },
    handleChange() {
      this.selectBank = this.bankList.find(
        item => item.id === this.form.accountId
      );
    },

    onInput() {
      if (this.form.amount > this.balance) {
        this.form.amount = this.balance;
      }
      if (this.form.amount <= 0) {
        this.form.amount = 0;
      }
    },
    handleClose() {
      this.$emit("close");
    },
    saveData() {
      this.btnLoading = true;
      if (!this.form.invoiceImage) {
        this.$message.error("请上传发票图片");
        this.btnLoading = false;
        return;
      }
      // this.form.amount = Number(this.form.amount);
      addBankListQuery(this.form)
        .then(() => {
          this.btnLoading = false;
          this.handleClose();
          this.$emit("save");
        })
        .catch(() => {
          this.btnLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.withdraw-item {
  display: flex;
  align-items: center;
  height: 60px;
  > span {
    margin-right: 10px;
    &.label {
      width: 120px;
      text-align: right;
      margin-right: 10px;
      font-weight: bold;
      color: #333;
      font-size: 15px;
      white-space: nowrap;
    }
    &.value {
      font-size: 15px;
      color: #333;
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
    }
  }
  ::v-deep .el-input {
    width: 200px;
  }
  ::v-deep .el-select {
    width: 200px;
  }
  ::v-deep .el-image {
    width: 40px;
    height: 40px;
    margin-right: 8px;
  }
}

.withdraw-bank {
  width: 100%;
  max-width: 500px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 15px 20px;
  margin: 0 auto;
  background-color: #f9f9f9;
  .withdraw-item {
    height: auto;
    min-height: 40px;
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    > span {
      &.label {
        width: 80px;
        font-size: 14px;
        padding-right: 10px;
      }
      &.value {
        font-size: 14px;
      }
    }
  }
}

// 添加截断文本样式
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 200px;
}

.bank-name {
  white-space: nowrap;
}

// 响应式样式
@media screen and (max-width: 768px) {
  .withdraw-item {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    // min-height: 60px;
    padding: 10px 0;

    > span {
      &.label {
        width: 100%;
        text-align: left;
        margin-right: 0;
        margin-bottom: 8px;
        font-size: 14px;
      }
      &.value {
        width: 100%;
        font-size: 14px;
      }
    }

    ::v-deep .el-input,
    ::v-deep .el-select {
      width: 100%;
    }
  }

  .withdraw-bank {
    width: 100%;
    margin: 10px 0;
    padding: 12px 15px;
    background-color: #fff;

    .withdraw-item {
      min-height: 40px;
      padding: 8px 0;
      flex-direction: row;
      align-items: center;

      > span {
        &.label {
          width: 80px;
          margin-bottom: 0;
          font-size: 13px;
        }
        &.value {
          flex: 1;
          font-size: 13px;
        }
      }
    }
  }

  // 移动设备上调整截断文本宽度
  .truncate {
    max-width: calc(100vw - 220px);
  }

  // 确保el-dialog在移动端正确显示
  ::v-deep .el-dialog {
    max-height: 90vh;
    overflow-y: auto;
    margin: 10vh auto !important;
  }
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
}

@media screen and (max-width: 480px) {
  .withdraw-item {
    padding: 8px 0;
  }

  .withdraw-bank {
    padding: 10px;
    border-radius: 8px;
  }

  .truncate {
    max-width: calc(100vw - 180px);
  }

  ::v-deep .el-dialog {
    width: 95% !important;
    margin: 5vh auto !important;
    max-height: 90vh;
  }
}
</style>
